import thermal1 from "../assets/t1.png";
import sofware1 from "../assets/aboutus-banner.png";
import thermal2 from "../assets/t2.png";
import React from "react";
import demovideo from "../assets/thermalDroneM_video.mp4";
import { Link } from "react-router-dom";
const ctaButtons = [
  {
    text: "Explore Services",
    link: "/services",
    className: "btn btn-warning btn-lg px-4",
  },
  {
    text: "Start Your Project",
    link: "/contact",
    className: "btn btn-outline-dark btn-lg px-4",
  },
];

export function Home() {
  return (
    <div className="page-bg home-bg">
      <div className="page-overlay">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="container py-5">
            <div className="row align-items-center min-vh-75">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="hero-content">
                  <span className="badge bg-warning text-dark mb-3 px-3 py-2">
                    Services till Last Mile
                  </span>
                  <h1 className="display-4 fw-bold mb-4">
                    Building Intelligent Software Solutions
                    <span className="text-warning d-block">
                      For Modern Businesses
                    </span>
                  </h1>
                  <p className="lead text-muted mb-4">
                    We design and develop custom software applications powered
                    by AI, computer vision, and cutting-edge technology. From
                    web platforms to mobile apps and specialized AI systems—we
                    transform your ideas into scalable, production-ready
                    solutions.
                  </p>
                  <div className="d-flex gap-3 flex-wrap">
                    {ctaButtons.map((btn, index) => (
                      <Link
                        key={index}
                        to={btn.link}
                        className={btn.className}
                        onClick={() =>
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                          })
                        }
                      >
                        {btn.text}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="hero-image-grid">
                  <div className="row g-3">
                    <div className="col-6">
                      <div className="tech-card">
                        <i className="bi bi-cloud-arrow-up fs-1 text-warning mb-2"></i>
                        <h6 className="fw-semibold mb-1">Cloud Solutions</h6>
                        <p className="small text-muted mb-0">
                          Scalable infrastructure
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tech-card">
                        <i className="bi bi-cpu fs-1 text-warning mb-2"></i>
                        <h6 className="fw-semibold mb-1">AI & ML</h6>
                        <p className="small text-muted mb-0">
                          Intelligent systems
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tech-card">
                        <i className="bi bi-globe fs-1 text-warning mb-2"></i>
                        <h6 className="fw-semibold mb-1">
                          Web and Mobile App Development
                        </h6>
                        <p className="small text-muted mb-0">
                          Modern web applications
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tech-card">
                        <i className="bi bi-phone fs-1 text-warning mb-2"></i>
                        <h6 className="fw-semibold mb-1">
                          Thermal AI Detection
                        </h6>
                        <p className="small text-muted mb-0">
                          Day & Night Vision Intelligence
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Core Services Section */}
        {/* <div className="services-section bg-light py-5">
          <div className="container py-4">
            <div className="text-center mb-5">
              <h2 className="fw-bold display-6 mb-3">Our Core Services</h2>
              <p className="text-muted lead">
                Comprehensive software development solutions tailored to your
                business needs
              </p>
            </div>
            <div className="row g-4">
              {CORE_SERVICES.map((service, idx) => (
                <div className="col-md-6 col-lg-4" key={idx}>
                  <div className="service-card card h-100 border-0 shadow-sm">
                    <div className="card-body p-4">
                      <div className="service-icon mb-3">
                        <div className="icon-circle bg-warning bg-opacity-10">
                          <i
                            className={`bi ${service.icon} text-warning fs-3`}
                          ></i>
                        </div>
                      </div>
                      <h5 className="fw-bold mb-3">{service.title}</h5>
                      <p className="text-muted mb-3">{service.desc}</p>
                      <ul className="list-unstyled small">
                        {service.features.map((feature, i) => (
                          <li key={i} className="mb-2">
                            <i className="bi bi-check2 text-warning me-2"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Featured Project - Thermal AI */}
        <div className="featured-project-section py-5">
          <div className="container py-4">
            <div className="text-center mb-5">
              <span className="badge bg-dark text-white mb-3 px-3 py-2">
                Featured Project
              </span>
              <h2 className="fw-bold display-6 mb-3">
                Thermal AI Detection System
              </h2>
              <p className="text-muted lead">
                One of our specialized AI solutions - Advanced thermal imaging
                with intelligent detection
              </p>
            </div>

            <div className="row align-items-center mb-5">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h3 className="fw-bold mb-3">
                  Day & Night Vision Intelligence
                </h3>
                <p className="text-muted mb-4">
                  We developed a cutting-edge thermal AI detection system that
                  combines thermal camera technology with deep learning
                  algorithms. This solution enables accurate monitoring and
                  threat detection in complete darkness, fog, and adverse
                  weather conditions.
                </p>
                <div className="feature-highlights">
                  <div className="d-flex align-items-start mb-3">
                    <div className="highlight-icon me-3">
                      <i className="bi bi-check-circle-fill text-success fs-5"></i>
                    </div>
                    <div>
                      <h6 className="fw-semibold mb-1">
                        99%+ Detection Accuracy
                      </h6>
                      <p className="text-muted small mb-0">
                        Advanced AI models trained on thermal imagery
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start mb-3">
                    <div className="highlight-icon me-3">
                      <i className="bi bi-check-circle-fill text-success fs-5"></i>
                    </div>
                    <div>
                      <h6 className="fw-semibold mb-1">Real-time Processing</h6>
                      <p className="text-muted small mb-0">
                        Sub-100ms response time for instant alerts
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start">
                    <div className="highlight-icon me-3">
                      <i className="bi bi-check-circle-fill text-success fs-5"></i>
                    </div>
                    <div>
                      <h6 className="fw-semibold mb-1">24/7 Operation</h6>
                      <p className="text-muted small mb-0">
                        Reliable performance in any lighting or weather
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="position-relative">
                  <img
                    src={thermal1}
                    alt="Thermal AI detection system - daytime operation"
                    className="img-fluid rounded-4 shadow-lg"
                  />
                </div>
              </div>
            </div>

            <div className="row align-items-center mb-5">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="position-relative">
                  <img
                    src={thermal2}
                    alt="Thermal AI detection system - night operation"
                    className="img-fluid rounded-4 shadow-lg"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <h3 className="fw-bold mb-3">All-Weather Computer Vision</h3>
                <p className="text-muted mb-4">
                  Our custom-built computer vision algorithms process thermal
                  data in real-time, identifying objects, tracking movement, and
                  detecting anomalies even in zero-visibility conditions where
                  traditional cameras fail completely.
                </p>
              </div>
            </div>

            {/* Demo Video */}
            <div className="demo-video-section">
              <h4 className="fw-bold text-center mb-4">
                Live System Demonstration
              </h4>

              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="video-wrapper position-relative">
                    <div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-lg">
                      <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="bg-black w-100 h-100"
                      >
                        <source src={demovideo} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    <div className="video-info mt-3 text-center">
                      <small className="text-muted">
                        <i className="bi bi-play-circle me-2"></i>
                        Real-time thermal AI detection in various environmental
                        conditions
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Technology Stack */}
        {/* <div className="tech-stack-section bg-light py-5">
          <div className="container py-4">
            <div className="text-center mb-5">
              <h2 className="fw-bold display-6 mb-3">
                Technologies We Work With
              </h2>
              <p className="text-muted lead">
                Modern tech stack for building robust, scalable applications
              </p>
            </div>
            <div className="row g-4">
              {TECH_STACK.map((category, idx) => (
                <div className="col-md-6 col-lg-3" key={idx}>
                  <div className="tech-category-card card h-100 border-0 shadow-sm">
                    <div className="card-body p-4 text-center">
                      <i
                        className={`bi ${category.icon} fs-1 text-warning mb-3`}
                      ></i>
                      <h6 className="fw-bold mb-3">{category.category}</h6>
                      <div className="d-flex flex-wrap justify-content-center gap-2">
                        {category.technologies.map((tech, i) => (
                          <span
                            key={i}
                            className="badge bg-light text-dark border"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Why Choose Us */}
        <div className="why-choose-section py-5">
          <div className="container py-4">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="fw-bold display-6 mb-4">
                  Why Choose LastMileService?
                </h2>
                <p className="text-muted mb-4">
                  We're not just developers—we're your technology partners. From
                  concept to deployment and beyond, we deliver solutions that
                  drive real business results.
                </p>
                <div className="why-list">
                  <div className="why-item d-flex mb-4">
                    <div className="why-icon me-3">
                      <i className="bi bi-lightning-charge-fill text-warning fs-3"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Rapid Development</h5>
                      <p className="text-muted mb-0">
                        Agile methodology ensuring faster time-to-market without
                        compromising quality
                      </p>
                    </div>
                  </div>
                  <div className="why-item d-flex mb-4">
                    <div className="why-icon me-3">
                      <i className="bi bi-shield-check text-warning fs-3"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Quality Assurance</h5>
                      <p className="text-muted mb-0">
                        Rigorous testing and code review processes for reliable,
                        bug-free applications
                      </p>
                    </div>
                  </div>
                  <div className="why-item d-flex">
                    <div className="why-icon me-3">
                      <i className="bi bi-headset text-warning fs-3"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Dedicated Support</h5>
                      <p className="text-muted mb-0">
                        Ongoing maintenance and technical support to keep your
                        systems running smoothly
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="stats-grid">
                  <div className="row g-3">
                    <div className="col-6">
                      <div className="stat-box bg-warning bg-opacity-10 rounded-3 p-4 text-center">
                        <h2 className="fw-bold mb-1 text-warning">98%</h2>
                        <p className="small text-muted mb-0">
                          Client Satisfaction
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="stat-box bg-dark text-white rounded-3 p-4 text-center">
                        <h2 className="fw-bold mb-1">10+</h2>
                        <p className="small mb-0 opacity-75">
                          Projects Completed
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="stat-box bg-dark text-white rounded-3 p-4 text-center">
                        <h2 className="fw-bold mb-1">1+</h2>
                        <p className="small mb-0 opacity-75">
                          Years Experience
                        </p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="stat-box bg-warning bg-opacity-10 rounded-3 p-4 text-center">
                        <h2 className="fw-bold mb-1 text-warning">24/7</h2>
                        <p className="small text-muted mb-0">
                          Support Available
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="why-choose-image position-relative">
                  <img
                    src={sofware1} // Replace with your desired image path
                    alt="Why choose LastMileService - software development team"
                    className="img-fluid rounded-4 shadow-lg"
                  />
                  {/* Optional: Add a floating badge */}
                  <div className="position-absolute top-0 end-0 m-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
      </div>
    </div>
  );
}
